import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { BudgetManagementForm } from '@/components/forms/BudgetManagementForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditBudgetManagementPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { expenseType, id } = useParams<{ expenseType: string; id: string }>()
  const numericId = id ? Number(id) : undefined

  // Convert kebab-case URL format to title case for form
  const convertExpenseTypeFormat = (type: string): string => {
    const typeMap: Record<string, string> = {
      'issued-budget': 'Issued Budget',
      'truck-trip-expense': 'Truck Trip Expense',
      'parts-expense': 'Parts Expense',
      'other-expense': 'Other Expense',
      'driver-cash-advance': 'Driver Cash Advance',
      'helper-cash-advance': 'Helper Cash Advance',
    }
    return typeMap[type.toLowerCase()] || type
  }

  const formattedExpenseType = expenseType ? convertExpenseTypeFormat(expenseType) : undefined

  const handleSuccess = () => {
    navigate('/budget-management')
  }

  const handleCancel = () => {
    navigate('/budget-management')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Budget Record
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Budget Record details
            </Text>
          </CardHeader>
          <CardBody>
            <BudgetManagementForm 
              budgetManagementId={numericId} 
              budgetManagementExpenseType={formattedExpenseType} 
              onSuccess={handleSuccess} 
              onCancel={handleCancel}
              />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


